import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: () => import('../views/Welcome.vue')
  },
  {
    path: '/interview-session',
    name: 'RealtimeMockInterview',
    component: () => import('../views/RealtimeMockInterview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/skillSelect',
    name: 'SkillSelect',
    component: () => import('../views/SkillSelect.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/interview',
    name: 'Interview',
    component: () => import('../views/Interview.vue'),
    meta: { requiresAuth: true },
    props: (route) => ({ 
      categoryId: route.query.category_id,
      subTitle: route.query.sub_title
    })
  },
  {
    path: '/practice',
    name: 'Practice',
    component: () => import('../views/Practice.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/User.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/review',
    name: 'Review',
    component: () => import('../views/Review.vue'),
    meta: { requiresAuth: true },
    props: (route) => ({
      id: route.query.id,
      type: route.query.type,
      title: route.query.title,
      source: route.query.source
    })
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/Report.vue'),
    meta: { requiresAuth: true },
    props: (route) => ({
      id: route.query.id,
      title: route.query.title
    })
  },
  {
    path: '/realtime-detail',
    name: 'RealtimeDetail',
    component: () => import('../views/RealtimeDetail.vue'),
    meta: { requiresAuth: true },
    props: (route) => ({
      id: route.query.id,
      position: route.query.position
    })
  },
  {
    path: '/realtime-interview',
    name: 'RealtimeInterviewChat',
    component: () => import('../views/RealtimeInterviewChat.vue'),
    meta: { requiresAuth: true },
    props: (route) => ({
      position: route.query.position,
      category: route.query.category,
      subcategory: route.query.subcategory
    })
  },
  {
    path: '/realtime-report',
    name: 'RealtimeReport',
    component: () => import('../views/RealtimeReport.vue'),
    meta: { requiresAuth: true },
    props: (route) => ({
      id: route.query.id,
      position: route.query.position
    })
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 直接放行，让后端通过 Cookie 验证
  // 如果未登录，API 会返回 401，拦截器会自动处理并跳转到登录页
  next()
})

export default router 